var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"card d-flex align-stretch align-center"},[_c('v-img',{staticClass:"icon",attrs:{"alt":"icon","src":_vm.item.imgSrc}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.item.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }